import { render, staticRenderFns } from "./OrdersReportButton.vue?vue&type=template&id=6ae15266&"
import script from "./OrdersReportButton.vue?vue&type=script&lang=js&"
export * from "./OrdersReportButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports